import { render, staticRenderFns } from "./detailsSalesVolume.vue?vue&type=template&id=729fb405&scoped=true&"
import script from "./detailsSalesVolume.vue?vue&type=script&lang=js&"
export * from "./detailsSalesVolume.vue?vue&type=script&lang=js&"
import style0 from "./detailsSalesVolume.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detailsSalesVolume.vue?vue&type=style&index=1&id=729fb405&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729fb405",
  null
  
)

component.options.__file = "detailsSalesVolume.vue"
export default component.exports